// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentQuillEditor_wrapper__1LwaG","errorText":"ContentQuillEditor_errorText__2M0n3","error":"ContentQuillEditor_error__3dO04"};